module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/0aef65d0a222bef34b4fc49366a8101d.png";